var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaplesProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff697f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43834,
    stopColor: "#d0272e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#cb2026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a2026"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.79321,56.41766c-2.06262,0-3.63879,1.67609-3.63879,3.74231v11.64203c0,.04407.03571.07971.07971.07971h2.81445c.04401,0,.07971-.03564.07971-.07971v-11.81567h23.09967v11.81567c0,.04407.03571.07971.07971.07971h2.81805c.04401,0,.07971-.03564.07971-.07971v-11.64203c0-2.06622-1.57263-3.74231-3.64362-3.74231h-21.76862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.96936,48.17163l16.11835-9.30554c.78961-.45587.78961-1.59552,0-2.05139l-5.6098-3.23883-18.48676,10.67346,6.79382,3.9223c.36646.21155.81793.21155,1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.66705,38.86615l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21161-.81793-.21161-1.18439,0l-16.11816,9.30585c-.78961.45587-.78961,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.37012,63.14972l16.18445,9.34412c.76733.44305,1.72656-.11072,1.72656-.99677v-18.68817c0-.41125-.21942-.7912-.5755-.99683l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.72656.11072-1.72656.99683v18.68835c0,.41119.21942.7912.57556.99677Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaplesProductsScraper);
export default __webpack_public_path__ + "static/media/staples-products-scraper.8a44c87ac3de20743a9f4363934ded85.svg";
export { ForwardRef as ReactComponent };